var _g, _g2, _g3, _g4, _g5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPizza(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "emoji",
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "color"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f4aa41",
    stroke: "none",
    d: "M52.2637,19.7373c0.4765,0.4775,0.916,0.9775,1.3418,1.4854l2.9004-5.7286 c-11.3252-11.3252-29.6875-11.3252-41.0118,0l2.9004,5.7286c0.4258-0.5079,0.8653-1.0079,1.3418-1.4854 C28.7197,10.7539,43.2803,10.7539,52.2637,19.7373z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fcea2b",
    stroke: "none",
    d: "M53.6055,21.2227c-0.4258-0.5079-0.8653-1.0079-1.3418-1.4854c-8.9834-8.9834-23.544-8.9834-32.5274,0 c-0.4765,0.4775-0.916,0.9775-1.3418,1.4854L36,56L53.6055,21.2227z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 24,
    r: 5,
    fill: "#ea5a47",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 24,
    r: 3,
    fill: "#ea5a47",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 36,
    r: 3,
    fill: "#ea5a47",
    stroke: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "hair"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "skin"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "skin-shadow"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "line"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M52.2637,19.7373c0.4765,0.4775,0.916,0.9775,1.3418,1.4854l2.9004-5.7286c-11.3252-11.3252-29.6875-11.3252-41.0118,0 l2.9004,5.7286c0.4258-0.5079,0.8653-1.0079,1.3418-1.4854C28.7197,10.7539,43.2803,10.7539,52.2637,19.7373z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M53.6055,21.2227c-0.4258-0.5079-0.8653-1.0079-1.3418-1.4854c-8.9834-8.9834-23.544-8.9834-32.5274,0 c-0.4765,0.4775-0.916,0.9775-1.3418,1.4854L36,56L53.6055,21.2227z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 24,
    r: 5,
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 24,
    r: 3,
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 36,
    r: 3,
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPizza);
export default __webpack_public_path__ + "static/media/pizza.a5c8676f7886413b937373e081d2f3f1.svg";
export { ForwardRef as ReactComponent };